import { useCallback, useMemo } from 'react'
import { SetQuery, DecodedValueMap } from 'use-query-params'

import { CandidatesQueryParams } from '../../CandidatesContainer.types'

import { FilterRangeValue } from '@percent/lemonade'

export const isScoreFilterApplied = (queryParams: DecodedValueMap<CandidatesQueryParams>) =>
  queryParams.scoreMin != null || queryParams.scoreMax != null

export function useScoreFilter({
  scoreName,
  queryParams,
  setQueryParams
}: {
  scoreName: string | null | undefined
  queryParams: DecodedValueMap<CandidatesQueryParams>
  setQueryParams: SetQuery<CandidatesQueryParams>
}) {
  const scoreRange = useMemo<FilterRangeValue>(
    () => ({ min: queryParams.scoreMin ?? undefined, max: queryParams.scoreMax ?? undefined }),
    [queryParams.scoreMin, queryParams.scoreMax]
  )

  const sortsByScore = queryParams.sortBy === 'score'

  // scoreName must stay while either a bound or the score sort still needs it
  const handleScoreRangeChange = useCallback(
    ({ min, max }: FilterRangeValue) => {
      const keepScoreName = min !== undefined || max !== undefined || sortsByScore

      setQueryParams({
        scoreName: keepScoreName ? scoreName ?? undefined : undefined,
        scoreMin: min,
        scoreMax: max
      })
    },
    [scoreName, sortsByScore, setQueryParams]
  )

  return {
    scoreRange,
    scoreFilterApplied: isScoreFilterApplied(queryParams),
    handleScoreRangeChange
  }
}
